import { useCallback, useEffect, useMemo, useState } from "react";
import { evaluateRuleById } from "./utils";
const getRuleHandler = (option) => option.visible_check && "handler" in option.visible_check ? option.visible_check.handler : void 0;
const useOptionsVisibility = ({
  options,
  schemaForm,
  rules,
  preview
}) => {
  const hasAnyRule = useMemo(
    () => options.some((option) => !!getRuleHandler(option)),
    [options]
  );
  const computeOptionVisibilities = useCallback(
    () => options.map((option) => {
      const baseVisible = option.visible !== false;
      const handler = getRuleHandler(option);
      if (!handler) return baseVisible;
      const ruleSatisfied = evaluateRuleById(
        handler,
        schemaForm.getValues(),
        rules,
        preview
      );
      return ruleSatisfied ? baseVisible : !baseVisible;
    }),
    [options, schemaForm, rules, preview]
  );
  const [optionVisibilities, setOptionVisibilities] = useState(
    () => computeOptionVisibilities()
  );
  useEffect(() => {
    const compute = () => setOptionVisibilities(computeOptionVisibilities());
    compute();
    if (!hasAnyRule) return void 0;
    const subscription = schemaForm.watch(() => compute());
    return () => subscription.unsubscribe();
  }, [computeOptionVisibilities, schemaForm, hasAnyRule]);
  return optionVisibilities;
};
export {
  useOptionsVisibility
};
